_context.invoke(function(Nittro) {
    var builder = new Nittro.DI.ContainerBuilder({
        "params": {},
        "extensions": {
            "ajax": "Nittro.Ajax.Bridges.AjaxDI.AjaxExtension()",
            "forms": "Nittro.Forms.Bridges.FormsDI.FormsExtension()",
            "page": "Nittro.Page.Bridges.PageDI.PageExtension()",
            "flashes": "Nittro.Flashes.Bridges.FlashesDI.FlashesExtension()",
            "checklist": "Nittro.Extras.CheckList.Bridges.CheckListDI.CheckListExtension()",
            "dialogs": "Nittro.Extras.Dialogs.Bridges.DialogsDI.DialogsExtension()",
            "confirm": "Nittro.Extras.Confirm.Bridges.ConfirmDI.ConfirmExtension()",
            "dropzone": "Nittro.Extras.DropZone.Bridges.DropZoneDI.DropZoneExtension()",
            "keymap": "Nittro.Extras.Keymap.Bridges.KeymapDI.KeymapExtension()"
        },
        "services": {},
        "factories": {}
    });

    this.di = builder.createContainer();
    this.di.runServices();

});